export const Url_404 = (config?: {[key: string]: any}) => {

    // ESt Destructuring
    const { type } = config || {};

    console.warn(`url is not work! type => ${type ? type : 'unknow type'}`)

    return true
}